import { api } from "./api";

export async function fetchRevenueInvoices() {
  const { data } = await api.get("/admin/revenue/invoices");
  return data.invoices || [];
}

export async function syncRevenueInvoices() {
  const { data } = await api.post("/admin/revenue/invoices/sync");
  return data.invoices || [];
}

export async function fetchNextRevenueInvoiceNumber() {
  const { data } = await api.get("/admin/revenue/invoices/next-number");
  return data.invoice_number || "";
}

export async function fetchRevenueInvoiceClients() {
  const { data } = await api.get("/admin/clients");
  return Array.isArray(data) ? data : [];
}

export async function createRevenueInvoice(body) {
  const { data } = await api.post("/admin/revenue/invoices", body);
  return data.invoice;
}

export async function patchRevenueInvoice(invoiceId, body) {
  const { data } = await api.patch(`/admin/revenue/invoices/${invoiceId}`, body);
  return data;
}

export async function deleteRevenueInvoice(invoiceId) {
  const { data } = await api.delete(`/admin/revenue/invoices/${invoiceId}`);
  return data.deleted;
}

export async function previewInvoiceDueReminder(invoiceId) {
  const { data } = await api.get(`/admin/revenue/invoices/${invoiceId}/due-reminder/preview`);
  return data.preview;
}

export async function sendInvoiceDueReminder(invoiceId) {
  const { data } = await api.post(`/admin/revenue/invoices/${invoiceId}/due-reminder/send`);
  return data;
}
